import Cookies from 'js-cookie';
import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { log } from 'console';
import { authToken } from 'src/env';
import { environment } from 'src/environments/environment';

export const preAuthApiClientService = axios.create({
  baseURL: environment.REACT_APP_CLIENT_BASE_URL, // or same baseURL you use
  timeout: 30000,
  headers: {
    source: 'priceless-microsite',
  },
});

export const preAuthApiEndUserService = axios.create({
  baseURL: environment.REACT_APP_ENDUSER_BASE_URL, // or same baseURL you use
  timeout: 30000,
  headers: {
    source: 'priceless-microsite',
  },
});

const authenticatedRequest = async <T = any>(
  apiClient: AxiosInstance,
  url: string,
  method: 'get' | 'post' | 'put' | 'delete',
  data?: any
): Promise<T> => {
  // const token = Cookies.get('authToken');
  const token = authToken;

  const response = await apiClient.request<T>({
    url,
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      source: 'benefitportal',
    },
    data,
  });

  return response.data;
};

const authenticatedRequestForFormData = async <T = any>(
  apiClient: AxiosInstance,
  url: string,
  method: 'get' | 'post' | 'put' | 'delete',
  data?: any
): Promise<AxiosResponse<T>> => {
  const token = authToken;

  const response = await apiClient.request<T>({
    url,
    method,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
      source: 'benefitportal',
    },
    data,
  });

  return response; // ✅ return full response
};

const unauthenticatedRequest = async <T = any>(
  apiClient: AxiosInstance,
  url: string,
  method: 'get' | 'post' | 'put' | 'delete',
  data?: any
): Promise<T> => {
  const response = await apiClient.request<T>({
    url,
    method,
    headers: {
      source: 'blogportal',
    },
    data,
  });

  return response.data;
};

export {
  authenticatedRequest,
  authenticatedRequestForFormData,
  unauthenticatedRequest,
};
